<template>
  <div class="flex">
    <input
      v-model="formattedDate"
      type="date"
      :class="[
        'px-2 placeholder-tiara-300 text-blueGray-600 bg-white rounded text-sm border border-tiara-100 focus:outline-none focus:ring focus:ring-australianMint w-full ease-linear transition-all duration-150',
        inputClass || 'py-2',
      ]"
    />
  </div>
</template>

<script>
export default {
  name: "DatePicker",
  props: {
    modelValue: [Date, String, Object],
    inputClass: String,
  },
  emits: ["update", "update:modelValue"],
  computed: {
    formattedDate: {
      get() {
        if (!this.modelValue) return "";
        return this.$dayjs(this.modelValue).format("YYYY-MM-DD");
      },
      set(newValue) {
        if (!newValue) {
          this.$emit("update", "");
          this.$emit("update:modelValue", "");
          return;
        }
        const isoString = this.$dayjs(newValue)
          .toDate()
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
        this.$emit("update", isoString);
        this.$emit("update:modelValue", isoString);
      },
    },
  },
};
</script>
